
function funToApp(funName, opt,is_new) {
    var u = navigator.userAgent,
        app = navigator.appVersion;
    var data = null;
    var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //android终端或者uc浏览器
    var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    if (isAndroid) {
        if (window.android) {
            console.log("安卓APP---" + funName, ...opt);
            data = window.android[funName] && window.android[funName](...opt);
        }
    } else if (isiOS) {
        console.log("IOS---" + funName, [...opt]);
        if(is_new){
            //新版ios框架
            data = window.webkit && window.webkit.messageHandlers[funName].postMessage([...opt])
        }
        else{
            //旧版用这个方法
            data = window[funName] && window[funName](...opt);
        }
    }
    return data;
}



export default {
    // 前端调用客户端  根据类型和id跳转新页面
    igpJumpToNative: function (jump_tag, jump_tag_id) {
        funToApp('igpJumpToNative', arguments);
    },
    // 前端调用客户端  分享
    igpJumpToNativeShare: function (share_message) {
        funToApp('igpJumpToNativeShare', arguments);
    },
    // 前端调用客户端  跳转到联系客服页面
    srGoToContact: function () {
        funToApp('srGoToContact', arguments);
    },
    isIphonXSeries: function () {
        if (window !== 'undefined' && window && !/iphone/gi.test(window.navigator.userAgent)) return false;
        const xSeriesConfig = [
            {  //iPhone Xs（Max,Pro Max）
                devicePixelRatio: 3,
                width: 414,
                height: 896,
            },
            {  // iPhone XR（11）
                devicePixelRatio: 2,
                width: 414,
                height: 896,
            },
            {  // iPhone X（Xs,Pro）
                devicePixelRatio: 3,
                width: 375,
                height: 812,
            },
        ];
        const {
            devicePixelRatio,
            screen: {
                width, height
            }
        } = window;
        return xSeriesConfig.some(item => item.devicePixelRatio === devicePixelRatio && item.width === width && item.height === height);
    },
    //前端调用客户端 name 方法名称 params 参数
    srH5CallNativeMethodApp: function(name,params) {
        let str = JSON.stringify({
            'method_name': name, 
            'params': params
        })
        let is_new = false;
        if(name !== 'call_native_photo'){
            is_new = true;
        }
        funToApp('srH5CallNativeMethod', [str],is_new)
    },

};
